import { Link } from 'react-router';
import { T } from '../lib/strings.ts';
import { EmptyState } from '../components/Status.tsx';
import { IconSearch } from '../components/brand/icons.tsx';

export function NotFound() {
  return (
    <div className="flex max-w-3xl flex-col gap-4">
      <h1 className="page-title">{T.notFound}</h1>
      <EmptyState icon={<IconSearch size={22} />} title={T.notFound}>
        <Link to="/artifacts" className="font-semibold text-primary underline-offset-4 hover:underline">
          {T.nav.artifacts}
        </Link>
      </EmptyState>
    </div>
  );
}
